<template>
    <component :is="(listType === 'table') ? 'PageFull' : 'Page'" header="Мерчанты" type="white">
        <template v-slot:body>
            <div class="flex w-full mb-2 xl:mb-3 lg:mb-3" :class="{ 'px-3 py-2': listType === 'table' }">
                <IconField class="w-full">
                    <InputIcon>
                        <i class="pi pi-search" />
                    </InputIcon>
                    <InputText v-model="searchString" placeholder="Поиск" class="w-full border-2 border-round-lg"/>
                    <InputIcon v-if="searchString">
                        <i class="pi pi-times cursor-pointer" @click="searchString=''"/>
                    </InputIcon>
                </IconField>
            </div>
            <div class="w-full flex flex-row gap-2" :class="{ 'px-3 py-2': listType === 'table' }">
                <div v-if="merchants" class="w-full flex flex-1 flex-column px-0 mb-3 gap-3">
                    <div class="w-full flex gap-2 align-items-center
                        flex-column xl:flex-row lg:flex-row">
                        <div class="w-full flex flex-2 flex-row flex-wrap gap-2 align-items-center">
                            <Dropdown v-model="active" :options="activeList" @change="onActiveChange($event.value)" optionLabel="name" optionValue="value" placeholder="Активность" class="flex border-round-md border-2" size="small" />
                            <Dropdown v-model="online" :options="onlineList" @change="onOnlineChange($event.value)" optionLabel="name" optionValue="value" placeholder="Онлайн" class="flex border-round-md border-2" size="small" />
                            <MultiSelect v-model="filter.get_currency_code" :options="currencyDropdownOptions" optionLabel="name" optionValue="code" placeholder="Валюта приёма" :maxSelectedLabels="0" selectedItemsLabel="{0} выбрано" 
                                class="merchant_multi_filter flex border-round-md border-2" :filter="true" :showClear="true" size="small"/>
                            <MultiSelect v-model="filter.send_currency_code" :options="currencyDropdownOptions" optionLabel="name" optionValue="code" placeholder="Валюта выплаты" :maxSelectedLabels="0" selectedItemsLabel="{0} выбрано" 
                                class="merchant_multi_filter flex border-round-md border-2" :filter="true" :showClear="true" size="small"/>
                            <MultiSelect v-model="filter.get_bank_code" :options="bankDropdownOptions" optionLabel="name" optionValue="code" placeholder="Банк приёма" :maxSelectedLabels="0" selectedItemsLabel="{0} выбрано" 
                                class="merchant_multi_filter flex border-round-md border-2" :filter="true" :showClear="true" size="small"/>
                            <MultiSelect v-model="filter.send_bank_code" :options="bankDropdownOptions" optionLabel="name" optionValue="code" placeholder="Банк выплаты" :maxSelectedLabels="0" selectedItemsLabel="{0} выбрано" 
                                class="merchant_multi_filter flex border-round-md border-2" :filter="true" :showClear="true" size="small"/>
                            <Button @click="clearFilter" icon="pi pi-times" class="flex border-round-md surface-100 text-600 border-0" size="small"/>
                            <Button @click="loadMerchants" icon="pi pi-refresh" class="flex border-round-md surface-100 text-600 border-0" size="small"/>
                        </div>
                        <div class="w-full flex flex-1 flex-row gap-2 align-items-center 
                            justify-content-start xl:justify-content-end lg:justify-content-end">
                            <SelectButton v-model="listType" :options="listTypes" optionLabel="name" optionValue="value" aria-labelledby="basic" class="text-xs" size="small" />
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap flex-row gap-3 text-sm text-600 mb-2">
                        <span class="flex">Всего: {{ totalCount }}</span>
                        <span class="flex">Отфильтровано: {{ filteredCount }}</span>
                    </div>
                </div>
                <!-- <div class="flex mb-3">
                    <AddMerchant />
                </div> -->
            </div>
            <div class="w-full">
                <Paginator v-if="merchants && !loading" v-model:first="skip" :rows="rows" :totalRecords="totalCount"
                    :rowsPerPageOptions="[10, 20, 30, 50, 100]"
                    @update:rows="onChangeRows" @update:first="onChangeFirst"
                    template="PageLinks RowsPerPageDropdown" class="mb-2"/>
                <div v-if="merchants && !loading" class="w-full flex flex-column">
                    <ListMerchant v-if="listType === 'deposits'" :list="filteredMerchants" @merchant_updated="loadMerchants" />
                    <ListDeposits v-if="listType === 'reserves'" :list="filteredMerchants" @merchant_updated="loadMerchants" />
                    <MerchantTable v-if="listType === 'table'" :list="filteredMerchants" />
                </div>
                <div v-if="loading" class="flex w-full" :class="{ 'px-3 py-2': listType === 'table' }">  
                    <Skeleton height="3rem" class="border-radius-lg"/> 
                </div>
            </div>
            <Paginator v-if="merchants && !loading" v-model:first="skip" :rows="rows" :totalRecords="totalCount" 
                :rowsPerPageOptions="[10, 20, 30, 50, 100]"
                @update:rows="onChangeRows" @update:first="onChangeFirst"
                template="PageLinks RowsPerPageDropdown"/>
        </template>
    </component>
</template>

<script>
import Connect      from '@/assets/js/Connect'
import Helper       from '@/assets/js/Helper'
import AddMerchant  from '@/components/admin/merchant/Add.vue'
import ListMerchant from '@/components/admin/merchant/List.vue'
import ListDeposits from '@/components/admin/merchant/ListDeposits.vue'
import MerchantTable from '@/components/admin/merchant/Table.vue'
import Page         from '@/components/sides/Page.vue' 
import PageFull     from '@/components/sides/PageFull.vue'
import { CurrencyList } from '@/assets/js/classes/Currency.js'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'UsersList',
    data() {
        return {
            loading: false,
            users: {},
            merchants: {},
            rows: 30,
            skip: 0,
            totalCount: 0,
            filteredCount: 0,
            filteredMerchants: [],
            filter: {
                active: true,
                online: true,
                get_currency_code: [],
                send_currency_code: [],
                get_bank_code: [],
                send_bank_code: []
            },
            currencyDropdownOptions: [],
            bankDropdownOptions: [],
            listTypes: [
                {
                    name: 'Депозиты',
                    value: 'deposits'
                },
                {
                    name: 'Резервы',
                    value: 'reserves'
                },
                {
                    name: 'Таблица',
                    value: 'table'
                }
            ],
            listType: 'deposits',
            activeList: [
                {
                    name: 'Все',
                    value: null
                },
                {
                    name: 'Активные',
                    value: true
                },
                {
                    name: 'Неактивные',
                    value: false
                }
            ],
            active: true,
            onlineList: [
                {
                    name: 'Все',
                    value: null
                },
                {
                    name: 'В линии',
                    value: true
                },
                {
                    name: 'Не в линии',
                    value: false
                }
            ],
            online: true,
            searchString: null
        }
    },
    components: {
        AddMerchant,
        ListMerchant,
        ListDeposits,
        MerchantTable,
        Page,
        PageFull
    },
    watch: {
        filter: {
            handler() {
                this.loadMerchants()
            },
            deep: true
        },
        searchString() {
            this.applyClientFilters()
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        onActiveChange(val) {
            this.filter = { ...this.filter, active: val }
        },
        onOnlineChange(val) {
            this.filter = { ...this.filter, online: val }
        },
        clearFilter(){
            this.$nextTick(() => {
                this.active = null
                this.online = null
                this.filter = {
                    active: null,
                    online: null,
                    get_currency_code: [],
                    send_currency_code: [],
                    get_bank_code: [],
                    send_bank_code: []
                }
            })
        },
        applyClientFilters() {
            if (!this.merchants || Object.keys(this.merchants).length === 0) {
                this.filteredMerchants = []
                this.filteredCount = 0
                return
            }
            let result = Object.values(this.merchants)
            const val = this.searchString
            if (val && val.length > 0) {
                const q = val.toLowerCase()
                result = result.filter((v) => {
                    const byName = v.name && v.name.toLowerCase().includes(q)
                    const byUser = v.user_name && v.user_name.toLowerCase().includes(q)
                    return byName || byUser
                })
            }
            this.filteredMerchants = result
            this.filteredCount = result.length
        },
        async loadFilterDropdowns() {
            try {
                const cur = await CurrencyList.GetList(this.$store)
                this.currencyDropdownOptions = [
                    ...(cur || []).map((c) => ({
                        name: String(c.code || '').toUpperCase(),
                        code: c.code
                    }))
                ]
            } catch {
                this.currencyDropdownOptions = []
            }
            try {
                const banks = await BankList.GetList(this.$store)
                const lang = this.lang_
                const bObj = new BankList()
                bObj.items = banks || []
                this.bankDropdownOptions = [
                    ...(banks || []).map((b) => ({
                        name: bObj.GetTitle(b.code, lang) || b.code,
                        code: b.code
                    }))
                ]
            } catch {
                this.bankDropdownOptions = []
            }
        },
        onChangeRows(event) {
			this.rows = event;
			this.loadMerchants();
		},
        onChangeFirst(event) {
            this.skip = event;
            this.loadMerchants();
        },
        async loadMerchants() {
            this.loading = true
            this.merchants = []
            this.users = []
            let user_ids = []
            this.filteredMerchants = []

            let filter = {}
            if(this.filter.active !== undefined && this.filter.active !== null) filter.active = this.filter.active
            if(this.filter.online !== undefined && this.filter.online !== null) filter.online = this.filter.online
            if(Array.isArray(this.filter.get_currency_code) && this.filter.get_currency_code.length > 0) filter.get_currency_code = this.filter.get_currency_code
            if(Array.isArray(this.filter.send_currency_code) && this.filter.send_currency_code.length > 0) filter.send_currency_code = this.filter.send_currency_code
            if(Array.isArray(this.filter.get_bank_code) && this.filter.get_bank_code.length > 0) filter.get_bank_code = this.filter.get_bank_code
            if(Array.isArray(this.filter.send_bank_code) && this.filter.send_bank_code.length > 0) filter.send_bank_code = this.filter.send_bank_code

            const merchants = await this.connect.merchant_list(this.rows, this.skip, filter, {_id: -1}).then(res => res)
            if (merchants.result) {
                merchants.data.forEach(merchant => {
                    let m_id = merchant.user_id.toString()
                    user_ids.push(merchant.user_id)
                    this.merchants[m_id] = merchant
                })
                this.totalCount = merchants.total
            }

            /// ищем имена пользователей по id
            if(user_ids.length>0){
                const users = await this.connect.get_users_list_byids(user_ids, {name: true, telegram: true}).then(res => res)
                if(users.result){
                    for(const [k,v] of Object.entries(users.data)){
                        this.merchants[v._id].user_name = v.name
                        this.merchants[v._id].user_id = v._id.toString()
                        this.merchants[v._id].username = (v.telegram && v.telegram.username) ? v.telegram.username : null
                        this.users[v._id] = v
                    }
                }
            }
            this.loading = false
            this.applyClientFilters()
            try{ window.scrollTo({ top: 0, behavior: 'smooth' }) } catch(e){}
        },
        sort(array){
            return array.sort((a, b) => {
                if (a.active === b.active) {
                    return a.online === b.online ? 0 : a.online ? -1 : 1;
                }
                return a.active ? -1 : 1;
            });
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        await this.loadFilterDropdowns()
        await this.loadMerchants()
    }
}
</script>